import { Grid, TextField } from '@material-ui/core';
import { IBAN_REGEX } from 'config/constants';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import React from 'react';
import bankLogo from '_assets/register/bank-logo.svg';
import DocumentCard from '../DocumentCard';

/**
 * Returns the bank fields initial values, based on the given company
 * @param company
 * @returns {{iban: string, bankName: string}}
 */
export function bankFieldsInitialValues(company) {
  return {
    bankName: company?.bank_name ?? '',
    iban: company?.iban ?? '',
  };
}

export const bankValidationSchema = Yup.object({
  bankName: Yup.string().required('Champ obligatoire'),
  iban: Yup.string().matches(IBAN_REGEX, "Le format de l'IBAN n'est pas valide.").required('Champ obligatoire'),
});

export default function BankFields({ document, onDocumentChange, isEditing }) {
  const { errors, handleChange, initialValues, touched, values } = useFormikContext();

  return (
    <>
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            error={touched.bankName && Boolean(errors.bankName)}
            helperText={touched.bankName && errors.bankName}
            fullWidth
            label="Nom de votre banque"
            name="bankName"
            onChange={handleChange}
            value={values.bankName}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            error={touched.iban && Boolean(errors.iban)}
            helperText={touched.iban && errors.iban}
            fullWidth
            label="Numéro IBAN"
            name="iban"
            onChange={handleChange}
            value={values.iban}
            variant="outlined"
          />
        </Grid>
      </Grid>

      <Grid container item alignItems="flex-end" justifyContent="center" style={{ marginTop: '16px' }}>
        <DocumentCard
          disabled={!isEditing && !initialValues.bankName && !initialValues.iban}
          document={document}
          logo={bankLogo}
          name="Banque"
          onChange={onDocumentChange}
        />
      </Grid>
    </>
  );
}
